import React from 'react';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import PText from './PText';

const FooterStyle = styled.div`
  background-color: var(--deep-dark);
  padding-top: 10rem;
  .container {
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <FooterStyle>
      <div className="container">
        <div className="footer__col1">
          <h1 className="footer__col1__title">Gaurav</h1>
          <PText>
            A 2nd-year Computer Science and Engineering Under Grad currently
            working in domain Deep Learning and Computer Vision and have
            experience of flask, flutter and firebase.
          </PText>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Important Links"
            links={[
              {
                title: 'Home',
                path: '/',
                type: 'Link',
              },
              {
                type: 'Link',
                title: 'About',
                path: '/about',
              },
              {
                type: 'Link',
                title: 'Projects',
                path: '/projects',
              },
              {
                type: 'Link',
                title: 'Contact',
                path: '/contact',
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Contact Info"
            links={[
              {
                title: '+91 7895337291',
                path: 'tel:+91 7895337291',
              },
              {
                title: 'gauravhhh30@gmail.com',
                path: 'mailto:gauravhhh30@gmail.com',
              },
              {
                title: 'Near Quest Mall, Kolkata',
                path:
                  'https://www.google.com/maps/place/Quest+Mall/@22.5389519,88.3635651,17z/data=!3m1!5s0x3a0276de3a0370ad:0xbd3e6abebde73b82!4m12!1m6!3m5!1s0x3a0276dfad4bf901:0xfbbe370e3a5a4dc8!2sQuest+Mall!8m2!3d22.5393357!4d88.3655843!3m4!1s0x3a0276dfad4bf901:0xfbbe370e3a5a4dc8!8m2!3d22.5393357!4d88.3655843',
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="social Links"
            links={[
              {
                title: 'GitHub',
                path: 'https://github.com/ctrl-gaurav',
              },
              {
                title: 'LinkedIn',
                path: 'https://www.linkedin.com/in/gaurav-726239157/',
              },
              {
                title: 'Instagram',
                path: 'https://www.instagram.com/ig_itsgk/',
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <PText>
            © 2021 - Gaurav | Designed By{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://its-gk.github.io/"
            >
              its GK
            </a>{' '}
          </PText>
        </div>
      </div>
    </FooterStyle>
  );
}
